var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{attrs:{"hover":"","striped":"","tbody-tr-class":"cursor-pointer","items":_vm.items,"fields":_vm.fields,"show-empty":"","empty-text":"Нет данных"},on:{"row-clicked":function($event){return _vm.$emit('row-clicked', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }